export interface IdentitySnapshot {
  readonly epoch: number
  readonly accountId: string | null
}
let identity: IdentitySnapshot = { epoch: 0, accountId: null }
const listeners = new Set<(identity: IdentitySnapshot) => void>()

export function currentIdentity(): IdentitySnapshot {
  return identity
}
export function isCurrentIdentity(snapshot: IdentitySnapshot): boolean {
  return snapshot.epoch === identity.epoch
}
// Deliberate transitions invalidate even when both accounts are null (logout/broadcast).
export function changeIdentity(accountId: string | null): void {
  identity = { epoch: identity.epoch + 1, accountId }
  for (const listener of listeners) listener(identity)
}
export function establishIdentity(accountId: string): void {
  if (identity.accountId !== accountId) changeIdentity(accountId)
}
export function invalidateIdentity(snapshot: IdentitySnapshot): void {
  if (isCurrentIdentity(snapshot)) changeIdentity(null)
}
export function onIdentityChange(listener: (identity: IdentitySnapshot) => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
